module.exports = __webpack_public_path__ + "img/1.9bee6089.jpg";